import React from "react";
import { ReactComponent as BigDataIcon } from '../../../assets/icons/big-data.svg';
import { ReactComponent as MediaIcon } from '../../../assets/icons/media.svg';
import { ReactComponent as FromMapsIcon } from '../../../assets/icons/from-maps.svg';
import { ReactComponent as SocialIcon } from '../../../assets/icons/social.svg';
import { ReactComponent as LongArrowDownIcon } from '../../../assets/icons/long-arrow-down.svg';
import { ReactComponent as LongArrowUpIcon } from '../../../assets/icons/long-arrow-up.svg';
import { ReactComponent as EchoAnalyticsIcon } from '../../../assets/icons/echo-analytics-logo.svg';
import s from "../about-product.module.scss"

const AboutProductImage = (props) => {
    return(
        <div className={s.AboutProductImage}>
            <div className={s.topIconsBlocks}>
                <div>
                    <BigDataIcon />
                    <span>{props.getValue('BIG_DATA')}</span>
                </div>
                <div>
                    <MediaIcon />
                    <span>{props.getValue('MEDIA')}</span>
                </div>
                <div>
                    <FromMapsIcon />
                    <span>{props.getValue('REVIEWS_FROM_MAPS')}</span>
                </div>
                <div>
                    <SocialIcon />
                    <span>{props.getValue('SOCIAL')}</span>
                </div>
            </div>
            <div className={s.centerBlock}>
                <div className={s.longArrow}>
                    <LongArrowDownIcon />
                    <div className={s.arrowText}>
                        <span>{ props.getValue('MENTIONS') }</span>
                    </div>
                </div>
                <div className={s.longArrow}>
                    <LongArrowUpIcon />
                    <div className={s.arrowText}>
                        <span>{ props.getValue('KEYWORDS') }</span>
                    </div>
                </div>
                
            </div>
            <div className={s.EchoAnalyticsIconBlock}>
                <EchoAnalyticsIcon />
            </div>

        </div>
    )
}

export default AboutProductImage;